import { cn } from '@/lib/utils';

interface NewBadgeProps {
  className?: string;
}

export function NewBadge({ className }: NewBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center align-middle',
        'px-0.75 py-0.5',
        'text-xs font-semibold leading-none',
        'text-[#F67A7A]',
        'rounded',
        className
      )}
    >
      NEW
    </span>
  );
}
